/** A small set of HKT utility types based on https://github.com/poteat/hkt-toolbelt */
export var Hkt;
(function (Hkt) {
    class Kind {
    }
    Hkt.Kind = Kind;
    class Instantiable {
    }
    Hkt.Instantiable = Instantiable;
    Hkt.reify = (def) => def.hkt;
    class UnaryKind {
    }
    Hkt.UnaryKind = UnaryKind;
    Hkt.pipe = (...kinds) => In => kinds.reduce((out, kind) => kind.hkt(out), In);
})(Hkt || (Hkt = {}));
